module.exports = __webpack_public_path__ + "static/media/roller07.6a4b37d6.png";